import React from 'react';
import { bool, func, node, object, oneOf, oneOfType, string } from 'prop-types';
import { noop } from '@ajaibid/utils';
import { DivTagContainer } from './style';

const Tag = (props) => {
  const {
    active,
    bold,
    block,
    className,
    disabled,
    id,
    label,
    onClick,
    size,
    style,
    variant,
  } = props;

  const tagProps = { active, bold, block, disabled, size, variant };

  const handleClick = (e) => {
    if (!disabled) {
      onClick(e);
    }
  };

  return (
    <DivTagContainer
      id={id}
      className={className}
      role="button"
      style={style}
      data-testid={`tag-${id}`}
      onClick={handleClick}
      {...tagProps}
    >
      <span>{label}</span>
    </DivTagContainer>
  );
};

Tag.propTypes = {
  active: bool,
  bold: bool,
  block: bool,
  className: string,
  disabled: bool,
  icon: oneOfType([node, string]),
  id: string.isRequired,
  label: string.isRequired,
  onClick: func,
  onDelete: func,
  size: oneOf(['sm', 'md', 'lg']),
  style: object,
  variant: oneOf(['filled', 'outlined', 'squared']),
};

Tag.defaultProps = {
  active: false,
  bold: false,
  block: false,
  className: '',
  disabled: false,
  icon: '',
  onClick: noop,
  onDelete: null,
  size: 'sm',
  style: {},
  variant: 'outlined',
};

export default Tag;
